interface FaqIndexLayoutWords {
  header?: {
    caption?: string | null
  } | null
}

const SCRIPT_TAG_PATTERN = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gis

export interface FaqIndexLayoutSetting {
  title?: string | null
  headerImageUrl?: string | null
  headerImageAltText?: string | null
  headerImageLinkUrl?: string | null
  faviconUrl?: string | null
  styles?: readonly (string | null | undefined)[] | null
  scripts?: readonly (string | null | undefined)[] | null
  css?: string | null
  js?: string | null
  header?: string | null
  footer?: string | null
  siteName?: string | null
  template?: string | null
  words?: FaqIndexLayoutWords | null
  botId?: string | null
}

export interface FaqIndexLayoutData {
  styleLinks: string[]
  headerImageLinkUrl: string
  headerImageUrl: string
  headerImageAlt: string
  header: string
  footer: string
  js: string
  css: string
  scripts: string[]
  faviconUrl: string
  templateClassName: string
  className: string
  headerCaption: string
}

/**
 * FAQのカスタムHTMLからscriptタグを除去する
 */
export function stripScriptTags(html?: string | null): string {
  if (!html) {
    return ''
  }

  return html.replace(SCRIPT_TAG_PATTERN, '')
}

function chooseTemplate(botId: string, template: string) {
  if (['rarejob'].some(account => account === botId)) {
    return ''
  }
  return template
}

function toClassName(botId: string) {
  return `b-${botId}`
}

/**
 * FAQレイアウト描画に必要な値を setting から組み立てる
 */
export function buildFaqIndexLayoutData(
  setting: FaqIndexLayoutSetting,
  overrides: Partial<Pick<FaqIndexLayoutData, 'js' | 'scripts'>> = {}
): FaqIndexLayoutData {
  const styleLinks = (setting.styles || []).filter((value): value is string => !!value)
  const headerImageLinkUrl = setting.headerImageLinkUrl || ''
  const headerImageUrl = setting.headerImageUrl || ''
  const headerImageAlt = setting.headerImageAltText || setting.siteName || setting.title || ''
  const header = setting.header || ''
  const footer = setting.footer || ''
  const js = overrides.js ?? setting.js ?? ''
  const css = setting.css || ''
  const scripts =
    overrides.scripts ?? (setting.scripts || []).filter((value): value is string => !!value)
  const faviconUrl = setting.faviconUrl || ''
  const botId = setting.botId || ''
  const templateClassName = chooseTemplate(botId, setting.template || 'template-2')
  const className = toClassName(botId)
  const headerCaption = setting.words?.header?.caption || 'よくあるご質問（Q&A）'

  return {
    styleLinks,
    headerImageLinkUrl,
    headerImageUrl,
    headerImageAlt,
    header,
    footer,
    js,
    css,
    scripts,
    faviconUrl,
    templateClassName,
    className,
    headerCaption,
  }
}
